<template>
    <div>
        <div class="grid grid-cols-1 gap-4 py-6 text-center border-t lg:grid-cols-4 border-grey-200 text-1375xl sm:text-left high-contrast:border-yellow-300">
            <div>
                <span class="text-2xl">{{ __('Zamówienie') }}</span>
            </div>
            <div class="lg:col-span-3">

                <div v-for="(item, index) in cartData.items" :key="`item-${index}`">
                    <div class="grid items-center grid-cols-1 mb-8 sm:grid-cols-4 gap-x-4">
                        <div class="sm:col-span-2">
                            <p>{{ item.name }}</p>
                            <span v-if="item.type" class="block text-sm text-orange leading-none high-contrast:text-yellow-300/75 mb-2">
                                {{ item.type }}
                            </span>
                            <span class="block text-base text-grey-200 high-contrast:text-yellow-300/75" v-if="item.details">
                                {{ item.details }}
                            </span>
                            <span v-if="hasPromotionalCode && isPromotionalCodeAppliedToItem(item)" class="block text-xs text-orange">
                                <span v-html="promotionalCodeData(item, 'info')"></span>
                            </span>
                        </div>
                        <div>
                            <span>{{ item.quantity }} x {{ item.price | price }}</span>
                        </div>
                        <div>
                            <span
                                v-if="isPromotionalCodeAppliedToItem(item)"
                                class="text-orange block pt-4"
                            >
                                {{ promotionalCodeData(item, 'discounted_total_price') | price }}
                            </span>
                            <span class="block" :class="{'line-through text-sm': isPromotionalCodeAppliedToItem(item) }">
                                {{ item.total_price | price }}
                            </span>
                            <span class="block text-sm font-light text-grey-200 sm:absolute high-contrast:text-yellow-300/75" v-if="item.service_costs_price && item.service_costs_price > 0">
                                {{ __('Koszty serwisowe:') }} {{ item.service_costs_price | price }}
                            </span>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="grid grid-cols-1 gap-4 py-6 text-center border-t lg:grid-cols-4 border-grey-200 text-1375xl sm:text-left high-contrast:border-yellow-300">
            <div>
                <span class="text-2xl">{{ __('Dane klienta') }}</span>
            </div>
            <div class="lg:col-span-3">
                <span class="block">{{ client.first_name + " " + client.last_name }}</span>
                <span class="block text-base text-grey-200 high-contrast:text-yellow-300/75">
                    {{ __('Adres e-mail') }}: {{ client.email }}, {{ __('nr telefonu') }}: {{ client.phone }}
                </span>

                <span class="block mt-2 text-base text-grey-200 high-contrast:text-yellow-300/75" v-if="registration.register">
                    {{ __('Podczas realizacji zamówienia zostanie utworzone konto klienta.') }}
                </span>
            </div>
        </div>

        <div class="grid grid-cols-1 gap-4 py-6 text-center border-t lg:grid-cols-4 border-grey-200 text-1375xl sm:text-left high-contrast:border-yellow-300">
            <div>
                <span class="text-2xl">
                    {{ __('Dostawa') }}
                    <sup class="text-orange uppercase text-xs" v-if="hasFreeShipping">{{ __('Darmowa dostawa') }}</sup>
                </span>
            </div>
            <div class="lg:col-span-3">
                <div class="grid items-center grid-cols-1 sm:grid-cols-4 gap-x-4" v-if="isDeliveryRequired">
                    <div class="sm:col-span-3">
                        <p>{{ deliveryType.name }}</p>
                        <p class="text-base text-grey-200 high-contrast:text-yellow-300/75">
                            <template v-if="! _.isEmpty(pickupPoint)">
                                {{ pickupPoint.address.line1 + (pickupPoint.address.line2.length > 0 ? (", " + pickupPoint.address.line2) : "") }}
                            </template>
                            <template v-else>
                                {{ address.street }} {{ address.house_number }}, {{ address.postcode }} {{ address.city }}
                            </template>
                        </p>
                    </div>
                    <div>
                        <span>
                            {{ deliveryType.price | price }}
                            <sup class="text-orange uppercase text-xs line-through" v-if="hasFreeShipping || hasDiscountedDelivery">{{ deliveryType.original_price | price }}</sup>
                        </span>
                    </div>
                </div>
                <div class="grid items-center grid-cols-1 gap-x-4" v-else>
                    <div v-if="hasAnyTicketOrdered">
                        <p>{{ __('Link do pobrania biletów elektronicznych zostanie wysłany mailem, sprawdź również spam') }}</p>
                    </div>
                    <div v-if="hasAnyGiftCardOrdered">
                        <p>{{ __('Karta podarunkowa zostanie przesłana mailem, sprawdź również spam') }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="grid grid-cols-1 gap-4 py-6 text-xl text-center border-t lg:grid-cols-4 border-grey-200 sm:text-left high-contrast:border-yellow-300">
            <div>
                <span class="text-2xl">{{ __('Płatność') }}</span>
            </div>
            <div class="lg:col-span-3">
                <div class="grid items-center grid-cols-1 sm:grid-cols-4 gap-x-4">
                    <div class="sm:col-span-3">
                        <span>{{ payment }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="grid grid-cols-1 gap-4 py-6 text-xl text-center border-t lg:grid-cols-4 border-grey-200 sm:text-left high-contrast:border-yellow-300" v-if="clientComments">
            <div>
                <span class="text-2xl">{{ __('Uwagi do zamówienia') }}</span>
            </div>
            <div class="lg:col-span-3">
                <div class="grid items-center grid-cols-1 sm:grid-cols-4 gap-x-4">
                    <div class="sm:col-span-3">
                        <span>{{ clientComments }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="grid grid-cols-1 gap-4 py-6 text-xl text-center border-t lg:grid-cols-4 border-grey-200 sm:text-left high-contrast:border-yellow-300" v-if="invoice.show_form">
            <div>
                <span class="text-2xl">{{ __('Faktura') }}</span>
            </div>
            <div class="lg:col-span-3">
                <div class="grid items-center grid-cols-1 sm:grid-cols-4 gap-x-4">
                    <div class="sm:col-span-3">
                        <span>
                            {{ invoice.name }} <span v-if="invoice.nip">({{ __('NIP') }}: {{ invoice.nip }})</span>
                        </span>
                        <p class="block text-base text-grey-200 high-contrast:text-yellow-300/75">
                            {{ invoice.street }} {{ invoice.house_number }}, {{ invoice.postcode }} {{ invoice.city }}
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="hasPromotionalCode && totalDiscountedPrice !== totalPrice" class="grid grid-cols-1 gap-4 py-6 text-xl text-center border-t lg:grid-cols-4 border-grey-200 sm:text-left high-contrast:border-yellow-300">
            <div>
                <span class="text-2xl">{{ __('Kod promocyjny') }}</span>
            </div>
            <div class="lg:col-span-3">
                <div class="grid items-center grid-cols-1 sm:grid-cols-4 gap-x-4">
                    <div class="sm:col-span-3">
                        <span class="block">{{ cartData.promotional_code }}</span>
                    </div>
                    <div>
                        - {{ cartData.total_discount_value | price }}
                    </div>
                </div>
            </div>
        </div>

        <div class="grid grid-cols-1 gap-4 py-6 text-center border-t lg:grid-cols-4 border-grey-200 text-1375xl sm:text-left high-contrast:border-yellow-300">
            <div></div>
            <div class="lg:col-span-3">
                <div class="grid grid-cols-1 sm:grid-cols-4 gap-x-4">
                    <div class="px-5 sm:col-span-3 sm:text-right">
                        <span>{{ __('W sumie do zapłaty') }}</span>
                    </div>
                    <div>
                        <span class="text-3xl text-orange" v-if="hasPromotionalCode && totalDiscountedPrice !== totalPrice">
                            {{ totalDiscountedPrice | price }}
                        </span>
                        <span class="font-bold" :class="[hasPromotionalCode && totalDiscountedPrice !== totalPrice ? 'line-through text-sm' : 'text-3xl text-orange']">
                            {{ totalPrice | price }}
                        </span>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex flex-col-reverse justify-between py-8 text-center lg:flex-row">
            <button
                v-on:click="$emit('back-to-prev-step')"
                class="flex items-center justify-center block w-full px-4 py-2 my-2 text-xl text-white rounded lg:my-8 bg-grey hover:bg-orange lg:w-1/3 font-secondary"
            >
                {{ __('Wróć do poprzedniego kroku') }}
            </button>
            <button @click="saveOrder" class="flex items-center justify-center block w-full px-4 py-2 my-2 text-white rounded lg:my-8 bg-orange lg:w-1/3 text-1375xl font-secondary high-contrast:bg-yellow-300 high-contrast:text-black">
                <span>{{ __('Zamawiam z obowiązkiem zapłaty') }}</span>
                <arrow-right class="inline w-4 ml-4 fill-white high-contrast:fill-black"></arrow-right>
            </button>
        </div>
    </div>
</template>

<script>
import ArrowRight from '@/front/components/Icons/ArrowRight';

export default {
    props: {
        cartData: {
            cartData: Object,
            required: true,
        },
        client: Object,
        payment: String,
        deliveryType: Object,
        address: Object,
        invoice: Object,
        registration: Object,
        pickupPoint: Object,
        isDeliveryRequired: Boolean,
        clientComments: String,
        hasFreeShipping: Boolean,
        hasAnyTicketOrdered: false,
        hasAnyGiftCardOrdered: false,
    },
    components: {
        ArrowRight
    },
    computed: {
        totalPrice() {
            if(this.deliveryType == null) {
                return this.cartData.total_price;
            }

            let totalPrice = parseFloat(this.cartData.total_price);

            if(this.hasFreeShipping) {
                return totalPrice;
            }

            return totalPrice + parseFloat(this.deliveryType.original_price);
        },
        totalDiscountedPrice() {
            if(this.deliveryType == null) {
                return _.get(this.cartData, 'total_discounted_price', this.cartData.total_price);
            }

            return parseFloat(_.get(this.cartData, 'total_discounted_price', this.cartData.total_price)) + parseFloat(this.deliveryType.price);
        },
        hasPromotionalCode() {
            return ! _.isEmpty(this.cartData.promotional_code);
        },
        hasDiscountedDelivery() {
            return this.deliveryType && this.deliveryType.price !== this.deliveryType.original_price;
        }
    },
    methods: {
        saveOrder() {
            this.$emit('save-order')
        },
        isPromotionalCodeAppliedToItem(item) {
            return ! _.isEmpty(_.get(item, 'promotional_code_data'));
        },
        promotionalCodeData(item, key) {
            return _.get(item, `promotional_code_data.${key}`, null)
        },
    }
};
</script>
